<template>
  <div class="bg-white px-4 pb-2 pt-5 mobile:p-6 mobile:pb-2">
    <slot />
  </div>
</template>
